
import styled from "styled-components";

export const DeviceAlarmsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 10px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
`;
export const AlarmEvents = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    overflow: hidden;
    //padding-top: 10px;
`;

export const TableHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding-bottom: 5px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    margin-bottom: 5px;
    
`;

export const TableContent = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    overflow-y: hidden;
    max-height: 60px; 
    position: relative;

    &::-webkit-scrollbar {
        width: 0px;
        display: none;
    }
`;

export const TableHeaderRow = styled.div`
    display: grid;
    width: 100%;
    grid-template-columns: 1.2fr 2fr 0.8fr;
    grid-gap: 5px;
    align-items: center;
    justify-items: stretch;
    background-color: rgba(255, 255, 255, 0.05);
    font-size: 12px;
    font-style: normal;
    
    & div {
        padding-top: 3px;
        padding-bottom: 3px;
        background-color: rgba(255, 255, 255, 0.1);
    }
`;

export const TableRow = styled.div`
    display: grid;
    width: 100%;
    grid-template-columns: 1.2fr 2fr 0.8fr;
    grid-gap: 5px;
    align-items: center;
    justify-items: stretch;
    font-size: 12px;
    font-style: normal;
    padding: 5px 0px;
    cursor: pointer;
    position: relative;

    &::after {
        content: '';
        position: absolute;
        height: 1px;
        width: 100%;
        bottom: 0px;
        background: linear-gradient(90deg, rgba(255, 255, 255, 0.025) 0%, rgba(255, 255, 255, 0.075) 50%, rgba(255, 255, 255, 0.025) 100%);
    }

    &:nth-child(even) {
        
    }
    
    &:hover {
        background: linear-gradient(0deg, rgba(55, 72, 108, 0.5) 0%, rgba(55, 72, 108, 0.0) 50%, rgba(55, 72, 108, 0.5) 100%);
    }

    &:hover:nth-child(even) {
        background: linear-gradient(0deg, rgba(55, 72, 108, 0.5) 0%, rgba(55, 72, 108, 0.0) 50%, rgba(55, 72, 108, 0.5) 100%);
    }

`;

export const DeviceName = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0px 5px;
`;

export const EventTime = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    box-sizing: border-box;

    &.value {
        padding-top: 2px;
        padding-bottom: 2px;
    }
`;

export const EventDetails = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
`;

export const EventStatus = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    justify-content: center;
`;